import FeatureSectionWrapper from '../FeatureSection/FeatureSectionWrapper';
import Enphase from '@/images/products/enphase-logo-2.png';
import Rec from '@/images/products/rec-solar-logo.png';
import Qcells from '@/images/products/qcells-logo.png';
import Solaredge from '@/images/products/solaredge-logo.png';
import Sunnova from '@/images/products/sunnova.png';
import Goodleap from '@/images/products/goodleap-logo.png';
import Tesla from '@/images/products/tesla-energy-logo.png';
import Everbright from '@/images/products/everbrightlogo.svg';
import Dividend from '@/images/products/dividendLogo.png';
import Solaria from '@/images/products/solariaLogo.png';
import Generac from '@/images/products/generacLogo.png';
import Axia from 'images/products/axiaLogo.png';
import Image from 'next/legacy/image';

export default function ProductsLogoCloud() {
  return (
    <FeatureSectionWrapper title="EnergyPal offers only top-rated solar &amp; battery solutions">
      <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-4 lg:mt-8">
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          {/* <div className="flex items-center max-h-12">
            <Image src={Sunpower} alt="SunPower solar panels and batteries" />
          </div> */}
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Axia}
              alt="Axia solar panels and batteries"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          {/* <div className="flex items-center max-h-12">
            <Image src={Enphase} alt="Enphase inverters and batteries" />
          </div> */}
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Enphase}
              alt="Enphase inverters and batteries"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Rec}
              alt="REC solar panels"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Qcells}
              alt="Q CELLS solar panels"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Tesla}
              alt="Tesla Energy batteries: Powerwall 2"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Solaredge}
              alt="SolarEdge solar inverters"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Sunnova}
              alt="Sunnova solar financing: lease, loan, and PPAs"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Goodleap}
              alt="Goodleap solar loans"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Dividend}
              alt="Dividend Solar"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Everbright}
              alt="Everbright Solar"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Solaria}
              alt="Solaria Solar"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
        <div className="flex justify-center col-span-1 px-8 py-8 bg-gray-50">
          <div className="relative flex items-center w-full h-12">
            <Image
              src={Generac}
              alt="Solaria Solar"
              layout="fill"
              objectFit="contain"
              objectPosition="center center"
            />
          </div>
        </div>
      </div>
    </FeatureSectionWrapper>
  );
}
